import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"
import useSortData from './useSortData';

export default function useCategories(props, emit, categoryData) {

    // Get toast interface
    const toast = useToast()

    const categoryIsInMenu = ref("")
    const search = ref("")
    const perPage = ref(10)
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getCategories = (url = null) => {
        store.dispatch("getCategories", {
            url,
            search: search.value,
            is_in_menu: categoryIsInMenu.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const getAllCategories = () => {
        store.dispatch("getAllCategories")
    }

    const onSubmit = () => {
        loading.value = true
        if (categoryData.value.id) {
            store.dispatch('updateCategory', categoryData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("دسته بندی مورد نظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        getCategories()
                        getAllCategories()
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        } else {
            store
                .dispatch("createCategory", categoryData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success("دسته بندی با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        getCategories()
                        getAllCategories()
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        const input = document.getElementById("formFile")
        input.value = ""
        categoryData.value.category_image = null
        emit("close")
    }

    const { sortField, sortDirection, sortData } = useSortData(getCategories);

    const sortCategories = (field) => {
        sortData(field);
        getCategories();
    };


    return {
        show,
        categoryIsInMenu,
        search,
        perPage,
        sortField,
        sortDirection,
        loading,
        errors,
        getCategories,
        getAllCategories,
        onSubmit,
        closeModal,
        sortCategories,
    }
}